module.exports = __webpack_public_path__ + "static/media/Image-Footer.008d3742.png";